import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { AlertCircle } from 'lucide-react';

interface ErrorProps {
  title?: string;
  message?: string;
  show_back_button?: boolean;
  show_home_button?: boolean;
}

export default function Error({
  title = 'Something went wrong',
  message = 'An unexpected error occurred. Please try again.',
}: ErrorProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <Card className="max-w-md w-full">
        <CardHeader>
          <div className="flex items-center space-x-2">
            <AlertCircle className="h-6 w-6 text-red-500" />
            <CardTitle>{title}</CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <CardDescription className="text-base mb-6">
            {message}
          </CardDescription>
        </CardContent>
      </Card>
    </div>
  );
}
